module.exports = __webpack_public_path__ + "img/clsj.92ef1966.svg";